import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_ocr_branch_hdr_RowClass} from '../../../dbschema';


export class ClaimOcrBranchContainerModel extends BaseContainerModel {
  bl_aat_claim_ocr_branch_hdr: bl_aat_claim_ocr_branch_hdr_RowClass = new bl_aat_claim_ocr_branch_hdr_RowClass();
}
